import type { ReactNode } from "react";

import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export function ImageStripActionButton({
    label,
    className,
    onClick,
    children,
}: {
    label: string;
    className?: string;
    onClick: () => void;
    children: ReactNode;
}) {
    return (
        <Tooltip>
            <TooltipTrigger
                render={
                    <Button
                        type="button"
                        size="icon-sm"
                        variant="secondary"
                        aria-label={label}
                        className={className}
                        onPointerDown={(event) => {
                            event.stopPropagation();
                        }}
                        onClick={onClick}
                    />
                }
            >
                {children}
            </TooltipTrigger>
            <TooltipContent side="bottom" positionerClassName="z-[600]">
                {label}
            </TooltipContent>
        </Tooltip>
    );
}
